import { useLocation } from "react-router-dom";

export default function useCanGoBack() {
  const location = useLocation();
  // React router V6 key has 'default' as initial value, or a hash if the navigation can go back.
  return location.key !== "default";
}
